'use client';
var classes = {"root":"m_6e45937b","loader":"m_e8eb006c","overlay":"m_df587f17"};

export { classes as default };
//# sourceMappingURL=LoadingOverlay.module.css.mjs.map
